import React, { useEffect, useState } from 'react';
// ROUTER
import { withRouter } from "../../utils/withRouter";

import LoadingIndicator from 'canvas-core-react/lib/LoadingIndicator';
import Margin from 'canvas-core-react/lib/Margin';
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import TextField from "canvas-core-react/lib/TextField";
import Column from 'canvas-core-react/lib/Column';
import Card from 'canvas-core-react/lib/Card';
import TextCaption from 'canvas-core-react/lib/TextCaption';
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import TextBody from 'canvas-core-react/lib/TextBody';
import Tooltip from 'canvas-core-react/lib/Tooltip';
import TextHeadline from 'canvas-core-react/lib/TextHeadline';
import Row from 'canvas-core-react/lib/Row';
import AlertBanner from 'canvas-core-react/lib/AlertBanner';

import { useAppContext } from "../../AppProvider";

import InputSelect from "../../components/InputSelect";
import InputAmount from "../../components/InputSelect/InputAmount";
import InputPlazo from '../../components/InputSelect/InputPlazo';

import IconPlug from "../../components/icons/IconPlug";
import BrandLine from "../../components/BrandLine";


import { CE_PRODUCTS, CE_SIMULATE, CE_CONTRACT, ROUTE_ONBOARDING, ROUTE_DAP } from '../../constants/endpoints'
import resolveEnv from '../../Helpers/resolveEnv'

import "./style.scss";
import { clickTagRut, simularTagging, stepsTagging_2 } from '../../utils/tagging';


const Simulator = ({ navigate, document, setShowError, showError }) => {
	const { state: context, changeItem, changeItem_ } = useAppContext();
	const [depositTypes, setDepositTypes] = useState([]);
	const [operationId, setOperationId] = useState([]);
	const [operationIdOnboarding, setOperationIdOnboarding] = useState();
	const [depositType, setDepositType] = useState(false);
	const [showSimulator, setShowSimulator] = useState(false);
	const [simulate, setSimulate] = useState('');
	const [errorSimulate, setErrorSimulate] = useState(false);
	const [showLoading, setShowLoading] = useState(false);
	const [btnSimulator, setBtnSimulator] = useState(true);
	const [showSimulation, setShowSimulation] = useState(false);
	const {
		currency,
		plazo,
		error_input_plazo,
		amount,
		error_input_amount
	} = context;
	const deshabilitarBtn = (!depositType || error_input_plazo || !plazo || !amount || error_input_amount) ? true : false;

	const ceURL = `${resolveEnv(CE_PRODUCTS)}/${document}`;
	const getUrl = () => fetch(ceURL, {
		method: 'GET',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB"
		},
	})
	.then(a => a.json())
	.then(a => {
		setOperationId(a);
		setDepositTypes(a.products);
		})
		.catch(a => setShowError(true));

	const ceURLSimulator = `${resolveEnv(CE_SIMULATE)}`;
	const getUrlSimulator = () => fetch(ceURLSimulator, {
		method: 'POST',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB"
		},
		body: JSON.stringify({
			operation_id: operationId.operation_id,
			type: depositType.type,
			currency: depositType.origin_currency_code,
			days: plazo,
			amount: amount
		}),

	})
		.then(a => a.json())
		.then(a => {
			setSimulate(a);
		})
		.catch(a => setSimulate('error'));

	const ceURLContract = `${resolveEnv(CE_CONTRACT)}`;
	const getUrlContract = () => fetch(ceURLContract, {
		method: 'POST',
		headers: {
			"Content-Type": "application/json",
			"x-channel": "SPUB"
		},
		body: JSON.stringify({
			operation_id: operationId.operation_id,
			url_init_dap: resolveEnv(ROUTE_DAP)
		}),
	})
		.then(a => a.json())
		.then(a => setOperationIdOnboarding(a))
		.catch(a => {

		});

	const handlePostSimulate = async () => {
		setSimulate(false);
		setErrorSimulate(false);
		try {
			const response = await getUrlSimulator();
			!response ? setErrorSimulate(false) : setErrorSimulate(true)
		}
		catch (error) {
			setErrorSimulate(true);
		}
	};

	const handlePostContract = async () => {
		setShowLoading(true)
		try {
			await getUrlContract();
		}
		catch (error) {
		}
	};

	const products = async () => {
		setShowError(false);
		try {
			const response = await getUrl();
		}
		catch (error) {
			setShowError(true);
		}
	};

	useEffect(() => {
		setShowLoading(false)
		setShowError(false)
		setShowSimulator(false)
		products();
		stepsTagging_2(document)
	}, []);

	useEffect(() => {
		simulate != ''&& simularTagging(document, depositType?.type, simulate?.profit_days, simulate?.initial_amount, simulate.period_rate)
	}, [simulate]);

	useEffect(() => {
		if (operationIdOnboarding && operationIdOnboarding.operation_id.length > 0) {
			window.parent.location.href = `${resolveEnv(ROUTE_ONBOARDING)}/${operationIdOnboarding.operation_id}`;
		}
	}, [operationIdOnboarding]);

	return (
		<>
			{showLoading ?
				<Margin side="both" lg={192} md={192} style={{ display: 'flex !important', justifyContent: 'center !important' }}>
					<LoadingIndicator
						accessibleTitle="Loading"
						size="large"
						style={{ display: 'flex !important', justifyContent: 'center !important' }}
					/>
				</Margin> :

				<Margin side="top" lg={60} md={60}>
					<div className="loading_container" style={{ display: 'flex !important', justifyContent: 'center !important' }}>
						{operationId.length == 0 && !showError ?
							<Margin side="both" lg={192} md={192} style={{ display: 'flex !important', justifyContent: 'center !important' }}>
								<LoadingIndicator
									accessibleTitle="Loading"
									size="large"
									style={{ display: 'flex !important', justifyContent: 'center !important' }}
								/>
							</Margin> :
							<>
								<Column lg={6} xs={4}>
									<div id="simulator_inputs_container">
										<Margin side="top" lg={32} md={32} />
										<InputSelect
											id={"simulator_depositType"}
											label={"Tipo de depósito"}
											placeholder={"Selecciona tipo"}
											value={depositType}
											setTo={setDepositType}
											tooltip={<TooltipDepositType document={document} />}
											options={{
												id: "type",
												description: "type",
												list: depositTypes,
											}} />
										<Margin side="top" lg={30} md={30} xs={18} sm={18} />
										<TextField
											id="simulator_currency"
											type="text"
											name="Moneda"
											label="Moneda"
											value={currency}
											placeholder={depositType?.deposit_currency_code}
											disabled
										/>
										<Margin side="top" lg={30} md={30} xs={18} sm={18} />
										<InputPlazo
											changeItem={changeItem}
											error_input_plazo={error_input_plazo}
											plazo={plazo}
											max_term_range={depositTypes[0]?.term_range.maximum}
											min_term_range={depositTypes[0]?.term_range.minimum}
										/>
										<Margin side="top" lg={30} md={30} xs={18} sm={18} />
										<InputAmount
											changeItem={changeItem_}
											error_input_amount={error_input_amount}
											amount={amount}
											max_amount_range={depositTypes[0]?.amount_range.maximum}
											min_amount_range={depositTypes[0]?.amount_range.minimum}
										/>

									</div>
								</Column>
								<Margin side="top" xs={24} sm={24} />
								<Column lg={6} style={{ textAlign: 'center' }} className='sim_hidden'>
									{!btnSimulator
										?
										<SecondaryButton
											style={{ width: '70%' }}
											labelPadding="36"
											disabled={deshabilitarBtn}
											onClick={() => {
												handlePostSimulate();
												setBtnSimulator(false);
											}}
										>
											Volver a simular
										</SecondaryButton>
										:
										<PrimaryButton
											style={{ width: '70%' }}
											labelPadding="36"
											disabled={deshabilitarBtn}
											onClick={() => {
												setSimulate('')
												handlePostSimulate();
												setShowSimulation(true);
												setBtnSimulator(false);
											}}
										>
											Simular
										</PrimaryButton>}
								</Column>
								<Margin side="bottom" xs={24} sm={24} />
								<Column lg={6} xs={4}>
									<Card type='floatLow' style={{ textAlign: 'center', paddingTop: '30px', paddingLeft: "12px", paddingRight: "12px" }}>
										{!showSimulation ?
											< div >
												<TextSubtitle>
													Importante<br />
												</TextSubtitle>
												<Margin side="top" lg={24} md={24} />
												<TextBody type='2'>
													Ingresa los datos solicitados y <br />te entregaremos la opción de Depósito a Plazo<br />que tenemos para ti.<br /><br />
													Si eres independiente podrás invertir hasta:<br />
													<b>{operationId?.max_amounts?.independent?.clp} {" "} ({operationId?.max_amounts?.independent?.usd})</b>
													<br /><br />
													Si eres dependiente podrás invertir hasta:<br />
													<b>{operationId?.max_amounts?.dependent?.clp}</b>
												</TextBody>
												<Margin side="bottom" lg={160} md={160} />
											</div> :
											!simulate ? <>
												<Margin side="bottom" lg={160} md={160} />
												<LoadingIndicator
													accessibleTitle="Loading"
													size="large"
													className='LoadingCenter'
												/>
												<Margin side="bottom" lg={160} md={160} />
											</>
												:
												!errorSimulate && simulate != 'error' ?
													<>
														<Margin xs={12} sm={12} side="top" />
														<p style={{ display: 'flex', justifyContent: 'center' }}>
															<span className="labelCard">Tasa exclusiva</span>
														</p>
														<TextSubtitle type='1'>
															Detalle de tu simulación<br />
														</TextSubtitle>
														<TextBody id="dataEntry_tooltip_textNew" type="2">
															Ganancia
															<TextSubtitle type='2'> {simulate.profit_days} días</TextSubtitle><br />
															<TextHeadline size='small' style={{ color: '#7849B8' }}> {simulate.profit}</TextHeadline><br />

															<Margin xs={6} sm={6} md={18} lg={18} side="top" />
															<Row className='sim_row'>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Tasa base (360 días)
																	</Margin>
																	<TextSubtitle style={{ color: '#7849B8' }} type="1" component="p" >{simulate.base_rate}</TextSubtitle>
																</Column>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Tasa período ({simulate.profit_days} días)
																	</Margin>
																	<TextSubtitle style={{ color: '#7849B8' }} type="1" component="p" >{simulate.period_rate}</TextSubtitle>
																</Column>
															</Row>

															<Margin xs={6} sm={6} md={18} lg={18} side="top" />
															<Row className='sim_row'>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Monto inicial
																	</Margin>
																	<TextBody bold type="2" component="p" >{simulate.initial_amount}</TextBody>
																</Column>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Monto final
																	</Margin>
																	<TextBody bold type="2" component="p" >{simulate.final_amount}</TextBody>
																</Column>
															</Row>

															<Margin xs={6} sm={6} md={18} lg={18} side="top" />
															<Row className='sim_row'>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Fecha de inversión
																	</Margin>
																	<TextBody bold type="2" component="p" >{simulate.investment_date}</TextBody>
																</Column>
																<Column xs={4} sm={4} md={6} lg={6}>
																	<Margin xs={6} sm={6} md={4} lg={4} side="bottom">
																		Fecha de vencimiento
																	</Margin>
																	<TextBody bold type="2" component="p" >{simulate.due_date}</TextBody>
																</Column>
															</Row>
														</TextBody>

														<Margin side="bottom" lg={72} md={72} />

													</>
													:
													<>
														<Margin side="top" xs={90} sm={60} md={4} lg={4}>
															<IconPlug />
														</Margin>
														<Margin side="top" xs={0} sm={24} md={24} lg={24}>
															<TextSubtitle type="1" component="h3">
																¡Vaya!
															</TextSubtitle>
															<TextSubtitle type="1" component="h3">
																Ha ocurrido un error
															</TextSubtitle>
														</Margin>
														<Margin side="top" xs={12} sm={24} md={24} lg={24}>
															<BrandLine />
														</Margin>
														<Margin xs={18} sm={36} md={36} lg={36}>
															<TextBody component="p">
																Por el momento hemos perdido la<br /> conexión, inténtalo nuevamente.
															</TextBody>
														</Margin>

														<Margin side="bottom" lg={96} md={96} />

														<Margin side="bottom" lg={48} md={48} />

													</>
										}
									</Card>
								</Column>

							</>
						}
					</div>
					<Margin side="top" lg={60} md={60} xs={24} sm={24} />
					<Row>
						<Column lg={6} style={{ textAlign: 'center' }} className='sim_hidden_1'>
							{!btnSimulator
								?
								<SecondaryButton
									style={{ width: '70%' }}
									labelPadding="36"
									disabled={deshabilitarBtn}
									onClick={() => {
										handlePostSimulate();
										setBtnSimulator(false);
										clickTagRut("volver-a-simular", document, "simulacion");
									}}
								>
									Volver a simular
								</SecondaryButton>
								:
								<PrimaryButton
									style={{ width: '70%' }}
									labelPadding="36"
									disabled={deshabilitarBtn}
									onClick={() => {
										setSimulate('')
										handlePostSimulate();
										setShowSimulation(true);
										setBtnSimulator(false);
										clickTagRut("simular", document, "simulador");
									}}
								>
									Simular
								</PrimaryButton>}
						</Column>
						<Column lg={6} style={{ textAlign: 'center' }}>
							<PrimaryButton
								style={{ width: '70%' }}
								labelPadding="36"
								disabled={btnSimulator || simulate == 'error' || simulate == ''}
								onClick={() => {
									handlePostContract();
									clickTagRut("ir-a-contratar", document, "simulacion")
								}
								}
							>
								Ir a contratar
							</PrimaryButton>
						</Column>
					</Row>

					<Margin side="top" lg={24} md={24} />

					<TextBody type="1" component="p" style={{ padding: '24px' }} className='sim_text'>
						Esta oferta incluye, sin costo,
						<TextBody bold type="1" className='sim_text'>  una Cuenta Corriente en pesos,
							una Cuenta Corriente en dólares y una Tarjeta de Débito digital. </TextBody>
						Recuerda que podrás pagar el monto a invertir desde otros bancos.
					</TextBody>

					<Margin side="top" lg={36} md={36} />
					<Column lg={10} md={10} lgOffset={1}>
						<AlertBanner type="info" style={{ paddingLeft: '12px' }}>
							<TextBody type="2" component="p" >
								Si no deseas incluir la
								<TextBody bold type="2"> Cuenta Corriente en dólares con costo cero, </TextBody>
								debes ir a una sucursal y realizar la solicitud.
							</TextBody>
						</AlertBanner>
					</Column>

					<Margin side="top" lg={60} md={60} />
				</Margin >
			}</>
	);
};

const TooltipDepositType = (document) => {
	return (
		<span >
			<Tooltip
				onOpen={() => {
					clickTagRut("tooltip", document.document, "simulador")
				}
				}
				position="bottom"
				id="dataEntry_tooltip_depositType"
				heading={
					"Tipos de Depósitos"
				}
				closeButtonLabel="Cerrar"
				infoButtonLabel="dialog tooltip"
				iconAriaLabel="Tooltip for deposit type"
			>
				<TextCaption id="dataEntry_tooltip_textNew" type="3">
					<TextSubtitle type='3'>Plazo Fijo: </TextSubtitle>
					Según el plazo que indiques, recibirás el monto del capital invertido en tu cuenta de cargo.
					<br /><br />

					<TextSubtitle type='3'>Plazo Renovable: </TextSubtitle>
					Según el plazo que indiques, la inversión se renovará de forma automática.
				</TextCaption>

			</Tooltip>
		</span>
	)
}

export default withRouter(Simulator);
